import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import FeaturedShowcase from './FeaturedShowcase';
import Services from './Services';
import Gallery from './Gallery';
import About from './About';
import Customers from './Customers';
import ServiceArea from './ServiceArea';
import FAQ from './FAQ';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import Footer from './Footer';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">
        <Hero />
        <Services />
        <FeaturedShowcase />
        <ContactInfo variant="banner" />
        <Gallery />
        <About />
        <Customers />
        <ServiceArea />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
